import FontFade from '../FontFade';
import Swiper from '../Swiper';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFRightArrow from '@/components/UI/svg/CSR/Icons/EFArrowRight';
import { EfRightOutlined } from '@/element/icons';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/img/csr/pc/');

export default function B(): JSX.Element {
    const { useLang, useEffect, useState, Link } = useGlobal();
    const { t } = useLang('csr');

    // tab宽度
    const itemWidth = 320;
    // 间隔宽度
    const gap = 18;
    // 寄赠品高度
    const donateItemHeight = 500;

    const locationList = [
        {
            title: t('secB_list1_region'),
            description: t('secB_list1_desc'),
            icon: 'government_building',
        },
        {
            title: t('secB_list2_region'),
            description: t('secB_list2_desc'),
            icon: 'b-2',
            link: {
                text: t('secB_list3_link'),
                href: 'https://www.city.tottori.lg.jp/www/contents/1602489863036/index.html',
            },
        },
        {
            title: t('secB_list3_region'),
            description: t('secB_list3_desc'),
            location: t('secB_list1_region'),
            icon: 'b-3',
        },
        {
            title: t('secB_list4_region'),
            description: t('secB_list4_desc'),
            icon: 'government_building',
        },
    ];

    const donateList_1 = [
        t('secB_dItem2_list1'),
        t('secB_dItem2_list2'),
        t('secB_dItem2_list3'),
        t('secB_dItem2_list4'),
        t('secB_dItem2_list5'),
        t('secB_dItem2_list6'),
    ];

    const donateList_2 = [
        t('secB_dItem1_list1'),
        t('secB_dItem1_list2'),
        t('secB_dItem1_list3'),
        t('secB_dItem1_list4'),
        t('secB_dItem1_list5'),
        t('secB_dItem1_list6'),
        t('secB_dItem1_list7'),
        t('secB_dItem1_list8'),
        t('secB_dItem1_list9'),
        t('secB_dItem1_list10'),
        t('secB_dItem1_list11'),
        t('secB_dItem1_list12'),
        t('secB_dItem1_list13'),
    ];

    useEffect(() => {
        const ScrollMagic = (window as any).ScrollMagic;
        const controller = new ScrollMagic.Controller();

        const scene = new ScrollMagic.Scene({
            triggerElement: '.csrBSwiperBox',
            triggerHook: 1,
            offset: 100,
        }).setClassToggle('.csrBSwiperBox', 'show');

        controller.addScene(scene);
    }, []);

    // 寄赠品展开 & 页面滚动
    const [showContent, setShowContent] = useState(false);
    const handleDonateClick = () => {
        const secB = document.querySelector('.csr_pc_B') as HTMLElement;
        const target = secB.offsetTop + secB.clientHeight + (showContent ? -donateItemHeight : donateItemHeight) - window.innerHeight;
        window.scrollTo({
            top: target,
            behavior: 'smooth',
        });
        setShowContent(!showContent);
    };

    return (
        <div className={`csr_pc_B ${css.csr_pc_B}`}>
            <div className="container">
                <div className="csrTitle">
                    <FontFade offset={50}>{t('secB_title')}</FontFade>
                </div>
            </div>
            <Swiper itemWidth={itemWidth} gap={gap} className="csrBSwiperBox" isRightAlign={true}>
                {locationList.map((item: any) => (
                    <div
                        key={item.title}
                        className="listItem"
                        style={{
                            width: `${itemWidth}px`,
                            marginRight: `${gap}px`,
                        }}
                    >
                        <div>
                            <EFPic className="listItemImg" name={[`${item.icon}.webp`, `${item.icon}.png`]} />
                            <div className="b-title">{item.title}</div>
                            <div className="b-desc">{item.description}</div>
                            {item?.link && (
                                <Link className="b-link" href={item?.link?.href || '/'}>
                                    <div className="linkText">{item?.link?.text}</div>
                                    <div className="linkIcon">
                                        <EFRightArrow stroke={'#03060b'} />
                                    </div>
                                </Link>
                            )}
                        </div>
                    </div>
                ))}
            </Swiper>
            <div className="container">
                <div className="secB_dTitle" onClick={handleDonateClick}>
                    <span>{t('secB_dTitle')}</span>
                    <span className={`secB_dTitle_arrow ${showContent ? 'up' : ''}`}>
                        <div className="sec-b-downarrow">
                            <EfRightOutlined />
                        </div>
                    </span>
                </div>
                <div
                    className={`secB_dContent ${showContent ? 'show' : ''}`}
                    style={{
                        height: showContent ? `${donateItemHeight}px` : '0',
                    }}
                >
                    <div style={{ height: `${donateItemHeight}px` }}>
                        <div className="dItemTitle">{t('secB_dItem2_title')}</div>
                        {donateList_1.map((item: string) => (
                            <div className="dItem" key={item}>
                                <span></span> {item}
                            </div>
                        ))}
                        <div className="csr_b_donate">
                            <EFPic name={['b-donate.webp', 'b-donate.png']} />
                        </div>
                    </div>
                    <div style={{ height: `${donateItemHeight}px` }}>
                        <div className="dItemTitle">{t('secB_dItem1_title')}</div>
                        <div>
                            {donateList_2.map((item: string) => (
                                <div className="dItem" key={item}>
                                    <span></span>
                                    {item}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
